module.exports = __webpack_public_path__ + "img/scenarios-de-missions.9806b13c.jpg";